const PARALLAX_SENSITIVITY = 300;

let offsetX: 0;
let offsetY: 0;

function reset() { offsetX = offsetY = 0; }

export function hook() {
    reset();

    const parallax = Array.from(document.querySelectorAll(".parallax"));
    const navbar = document.querySelector(".navbar");

    document.addEventListener("mouseleave", reset);
    document.addEventListener("mouseenter", reset);
    document.addEventListener("mousemove", (e) => {
        offsetX -= e.movementX / PARALLAX_SENSITIVITY;
        offsetY -= e.movementY / PARALLAX_SENSITIVITY;

        parallax.forEach((el: any) => {
            el.style.marginLeft = `${offsetX}px`;
            el.style.marginTop = `${offsetY}px`;
        });
    });
}